import { render } from "./CorporatePlanTabsComponent.vue?vue&type=template&id=cf8b626c"
import script from "./CorporatePlanTabsComponent.vue?vue&type=script&lang=js"
export * from "./CorporatePlanTabsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__